module.exports = __webpack_public_path__ + "img/favicon.11cb643c.png";